var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploaduser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 91 91",
    enableBackground: "new 0 0 91 91",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.619,16.685c-10.5,0-19.045,8.545-19.045,19.051c0,10.504,8.545,19.051,19.045,19.051 c10.508,0,19.055-8.547,19.055-19.051C90.674,25.229,82.127,16.685,71.619,16.685z M79.365,38.407h-5.438v5.439 c0,1.385-1.123,2.506-2.506,2.506s-2.504-1.121-2.504-2.506v-5.439h-5.439c-1.383,0-2.506-1.121-2.506-2.506 c0-1.383,1.123-2.504,2.506-2.504h5.439v-5.436c0-1.383,1.121-2.504,2.504-2.504s2.506,1.121,2.506,2.504v5.436h5.438 c1.383,0,2.504,1.121,2.504,2.504C81.869,37.286,80.748,38.407,79.365,38.407z",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffa200",
    points: "25.506,55.183 21.086,78.269 26.541,82.632 31.99,78.272 27.504,55.183 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.961,47.731c-3.236,3.193-7.326,5.506-11.889,6.576l4.76,24.412c0.18,0.859-0.139,1.744-0.82,2.289 l-2.051,1.639c5.709-0.682,11.896-2.17,18.375-4.889V59.64C52.336,54.269,49.566,50.374,43.961,47.731z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.922,54.384c-4.67-1.041-8.855-3.381-12.152-6.635c-5.375,2.635-8.027,6.525-8.027,11.891v18.205 c2.584,1.201,9.234,3.908,18.488,4.896l-2.162-1.73c-0.682-0.547-1.002-1.428-0.826-2.283L20.922,54.384z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.35,50.341c11.309,0,20.506-9.262,20.506-20.648S37.658,9.044,26.35,9.044 c-11.299,0-20.492,9.262-20.492,20.648S15.051,50.341,26.35,50.341z",
    fill: "#ffffff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaduser);
export default __webpack_public_path__ + "static/media/uploaduser.e3a8da3a6e39324976005f7e56a6ecdd.svg";
export { ForwardRef as ReactComponent };